<template>
  <v-dialog width="500" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn icon small text v-on="on" title="Lista de endereços">
        <v-icon small>mdi-map-marker</v-icon>
      </v-btn>
    </template>
    <v-card :loading="loading">
      <v-card-title>
        {{ title }}
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <lista-endereco v-model="enderecos" />
    </v-card>
  </v-dialog>
</template>

<script>
import ListaEndereco from "./ListaEndereco";
export default {
  components: { ListaEndereco },
  props: ["tipo", "title", "IdEntidade"],
  data() {
    return {
      dialog: false,
      enderecos: [],
      loading: false,
    };
  },
  watch: {
    async dialog(open) {
      this.enderecos = [];
      if (open) {
        this.$emit("open");
        this.loading = true;
        try {
          this.enderecos = await this.$store.dispatch(
            "entidade/listarEnderecos",
            { tipo: this.tipo, id_entidade: this.IdEntidade }
          );
        } catch (err) {
          console.log(err);
          this.$store.commit("ui/setSnackbar", {
            text: "Não foi possível listar os endereços",
          });
        }
        this.loading = false;
      }
    },
  },
};
</script>
